module.exports = __webpack_public_path__ + "static/media/6.d169591.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/6.wav
// module id = qsC2
// module chunks = 0